function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React, { useLayoutEffect } from 'react';
import { Frame } from "./Frame";
export var PaymentsFrameAlreadyPaidError = /*#__PURE__*/function (_Error) {
  _inherits(PaymentsFrameAlreadyPaidError, _Error);
  var _super = _createSuper(PaymentsFrameAlreadyPaidError);
  function PaymentsFrameAlreadyPaidError() {
    var _this;
    _classCallCheck(this, PaymentsFrameAlreadyPaidError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _super.call.apply(_super, [this].concat(args)), _this.name = 'PaymentsFrameAlreadyPaidError', _assertThisInitialized(_this)));
  }
  return _createClass(PaymentsFrameAlreadyPaidError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var PaymentsFrameUnknownError = /*#__PURE__*/function (_Error2) {
  _inherits(PaymentsFrameUnknownError, _Error2);
  var _super2 = _createSuper(PaymentsFrameUnknownError);
  function PaymentsFrameUnknownError() {
    var _this2;
    _classCallCheck(this, PaymentsFrameUnknownError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return _possibleConstructorReturn(_this2, (_this2 = _super2.call.apply(_super2, [this].concat(args)), _this2.name = 'PaymentsFrameUnknownError', _assertThisInitialized(_this2)));
  }
  return _createClass(PaymentsFrameUnknownError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var PaymentsFrame = function PaymentsFrame(props) {
  useLayoutEffect(function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var listener = function listener(event) {
      var message = getPaymentMessageFromEvent(event);
      if (!message) {
        return;
      }
      if (message.error) {
        if (message.errorCode === 'alreadyPaid') {
          props.onError(new PaymentsFrameAlreadyPaidError('This order has already been paid for'));
        } else {
          props.onError(new PaymentsFrameUnknownError("Unknown payments frame error: ".concat(message.message || 'Unknown Error')));
        }
      } else {
        props.onSuccess();
      }
    };
    window.addEventListener('message', listener, false);
    return function () {
      window.removeEventListener('message', listener, false);
    };
  }, [props.onSuccess, props.onError]);
  return /*#__PURE__*/React.createElement(Frame, {
    orderId: props.orderId
  });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getPaymentMessageFromEvent = function getPaymentMessageFromEvent(event) {
  if (event.origin !== window.location.origin) {
    return null;
  }
  var json = event.data;
  if (typeof json === 'string') {
    var data = null;
    try {
      data = JSON.parse(json);
    } catch (err) {
      // do nothing
    }
    if (isPaymentMessage(data)) {
      return data;
    }
  }
  return null;
};
var isPaymentMessage = function isPaymentMessage(data) {
  return _typeof(data) === 'object' && data && typeof data.error === 'boolean' && (typeof data.errorCode === 'string' || typeof data.errorCode === 'undefined' || data.errorCode === null) && typeof data.orderId === 'string';
};